import { Button, WandSparklesIcon } from '@buffer-mono/popcorn'

/**
 *
 */
function AIAssistantTrigger({ onClick }: { onClick: () => void }): JSX.Element {
  return (
    <Button
      onClick={onClick}
      id="button-ai-assistant-v2"
      data-testid="button-ai-assistant"
      variant="tertiary"
    >
      <WandSparklesIcon />
      AI Assistant
    </Button>
  )
}

export { AIAssistantTrigger }
